// extracted by mini-css-extract-plugin
export default {"root":"QueryTypeSelect_root__SmVGl","container":"QueryTypeSelect_container__ZQ8AD"};